'use client'

import React, { useState } from 'react'
import TeamData from './team-data';
import TeamListCarousel from './team-list';
import PropTypes from 'prop-types'
import LineStroke from '../individual-components/line-stroke';
import { TEAMS_LIST } from '@/assets/data/constants';

const TeamCarousel = ({ context }) => {

    const [currentSlide, setCurrentSlide] = useState(1)

    return (
        <div>
            <div className="w-full max-w-7xl mx-auto px-6 sm:px-3 md:mb-12">
                <div className=" px-32 md:px-4 max-w-5xl mx-auto">
                    <div className="relative top-[-2.5rem] w-56 xs:w-1/2 mx-auto">
                        <LineStroke />
                    </div>
                    <h1 className="title text-center text-4xl md:text-3xl sm:text-2xl leading-[2.5rem] sm:leading-6 font-bold text-gray-900 max-w-6xl">{context?.header}</h1>
                    <p className="w-full mx-auto mt-3 text-xl sm:text-base text-center text-secondary ">{context?.description}</p>
                </div>

                <div className="container md:hidden px-6 mx-auto mt-20 sm:mt-10 pb-20 sm:pb-10 max-w-7xl">
                    <TeamListCarousel
                        currentSlide={currentSlide}
                        setCurrentSlide={setCurrentSlide}
                        items={TEAMS_LIST?.map(e => e?.label)}
                    />
                </div>
            </div>
            <TeamData
                currentSlide={currentSlide}
                items={TEAMS_LIST}
            />
        </div>
    )
}

TeamCarousel.propTypes = {
    context: PropTypes.object
}

export default TeamCarousel;
